import { useEffect, useState } from "react";
import { preventivoApi } from "@/api/preventivo";

/** Voce «Preventivo condomini»: per il personale dell'agenzia (`enabled`) e solo se lo
 * strumento è acceso per l'agenzia. Su errore la voce resta nascosta. */
export function usePreventivoAttivo(enabled: boolean): boolean {
  const [attivo, setAttivo] = useState(false);
  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    preventivoApi.stato()
      .then((s) => { if (alive) setAttivo(s.attivo); })
      .catch(() => { /* voce invisibile su errore */ });
    return () => { alive = false; };
  }, [enabled]);
  return attivo;
}
